const products = [
   
    {
      id: 3,
      name: "Fries Combo",
      category: "Sides",
      price: 2500,
      image:
        "https://images.unsplash.com/photo-1576107232684-1279f390859f?q=80&w=1200&auto=format&fit=crop",
        shopId: "shop001",
        shopName: "Shoppal Foods",
      
        vendorId: "1ZsSv7znpvWw2aRtHKmJfhU4lPD3"
    },

    {
      id: 4,
      name: "Chocolate Milkshake",
      category: "Drinks",
      price: 2800,

      image:
        "https://images.unsplash.com/photo-1577805947697-89e18249d767?q=80&w=1200&auto=format&fit=crop",
        shopId: "shop001",
        shopName: "Shoppal Foods",
      
        vendorId: "1ZsSv7znpvWw2aRtHKmJfhU4lPD3"
    },

    {
      id: 5,
      name: "Chicken Bucket",
      category: "Chicken",
      price: 12000,

      image:
        "https://images.unsplash.com/photo-1562967914-608f82629710?q=80&w=1200&auto=format&fit=crop",
        shopId: "shop001",
        shopName: "Shoppal Foods",
      
        vendorId: "1ZsSv7znpvWw2aRtHKmJfhU4lPD3"
    },

    {
      id: 6,
      name: "Ice Cream",
      category: "Desserts",
      price: 1800,

      image:
        "https://images.unsplash.com/photo-1563805042-7684c019e1cb?q=80&w=1200&auto=format&fit=crop",
        shopId: "shop001",
        shopName: "Shoppal Foods",
      
        vendorId: "1ZsSv7znpvWw2aRtHKmJfhU4lPD3"
    },
  ];
  
  export default products;

  